import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Crud, CrudService } from '../../../core';
import { TipoClassificacao } from '../tipo-classificacao';
import { TipoClassificacaoFilter } from '../filter';

@Injectable({
    providedIn: 'root'
})
export class TipoClassificacaoCrudHttpService implements Crud<TipoClassificacao> {
    resource = 'tipoclassificacao';

    constructor(private crudService: CrudService) { }

    /** Pesquisa todos os tipos de classificações cadastrados */
    search(): Observable<TipoClassificacao[]> {
        return this.crudService.search<TipoClassificacao>(this.resource);
    }

    /** Pesquisa todos os tipos de classificações cadastrados */
    searchWithFilter(filter: TipoClassificacaoFilter): Observable<TipoClassificacao[]> {
        // Params
        let params = new HttpParams();
        if (filter) {
            params = filter.createParams(params);
        }
        return this.crudService.search<TipoClassificacao>(this.resource, {params});
    }

    /** Procura um único tipo de classificação através do seu ID */
    find(id: number): Observable<TipoClassificacao> {
        return this.crudService.find<TipoClassificacao>(this.resource, id);
    }

    /** Carrega um único tipo de classificação através do seu ID */
    load(id: number): Observable<TipoClassificacao> {
        return this.crudService.load<TipoClassificacao>(this.resource, id);
    }

    /** Insere um novo tipo de classificação */
    insert(entity: TipoClassificacao): Observable<TipoClassificacao> {
        return this.crudService.insert<TipoClassificacao>(this.resource, entity);
    }

    /** Altera uma tipo de classificação existente */
    update(entity: TipoClassificacao): Observable<TipoClassificacao> {
        return this.crudService.update<TipoClassificacao>(this.resource, entity);
    }

    /** Exclui uma tipo de classificação através do seu ID */
    delete(id: number): Observable<string> {
        return this.crudService.delete(this.resource, id);
    }
}
